const { location } = window;
const { hostname } = location;
let currentHost = "";

if (hostname === "localhost") {
  currentHost = "http://localhost:56981";
} else if (hostname === 'dmjob.dmcardweb.com.br') {
  currentHost = `https://${hostname}`;
} else if (hostname === 'dmjobhml.dmcardweb.com.br') {
  currentHost = `https://${hostname}`;
} else {
  currentHost = `https://${hostname}`;
}

console.log(currentHost);

const API_URL = `${currentHost}/api`;
const IMAGE_PATH = `${currentHost}/`;
const IMAGE_PATHV2 = `${currentHost}`

export default {
  API_URL,
  IMAGE_PATH,
  IMAGE_PATHV2
};



// WEBPACK FOOTER //
// ./src/config/app-config.js